module.exports = __webpack_public_path__ + "img/collar width.f9814eb4.png";